import _props from '../props'

export default (props) => () => {

  _props.set(props)
  
}